import type { FrappeDoctypeLookupOption } from "@/api/frappeLookupApi";

export const DEFAULT_MODE_OF_PAYMENT = "Cash";

export function createModeOfPaymentOption(
  value: string = DEFAULT_MODE_OF_PAYMENT,
): FrappeDoctypeLookupOption {
  return {
    id: value,
    label: value,
    raw: {
      name: value,
    },
  };
}

export function createDefaultModeOfPaymentOption(
  value: string = DEFAULT_MODE_OF_PAYMENT,
) {
  return createModeOfPaymentOption(value);
}
